export const API_KEY = process.env.REACT_APP_API_THEMOVIEDATEBASE_KEY; 
export const API_URL = process.env.REACT_APP_API_THEMOVIEDATEBASE_URL;